import { Routes } from '@angular/router';

import { authGuard } from '@/core/guards/auth-guard';
import { roleGuard } from '@/core/guards/role.guard';

import { AppLayout } from '@/layout/component/app.layout';
import { Dashboard } from '@/pages/dashboard/dashboard';

import { Documentation } from '@/pages/documentation/documentation';
import { Landing } from '@/pages/landing/landing';
import { Notfound } from '@/pages/notfound/notfound';

export const appRoutes: Routes = [
  {
    path: '',
    component: AppLayout,
    canActivate: [authGuard],
    children: [
      // ✅ admin + athlete
      { path: '', component: Dashboard, canActivate: [roleGuard([1, 3])] },

      {
        path: 'athlete-info',
        loadComponent: () => import('./app/project/athlete-info/athlete-info.page').then((m) => m.AthleteInfoPage),
        canActivate: [roleGuard([1, 3])],
      },

      // ✅ فقط admin
      {
        path: 'SportDiscipline',
        loadComponent: () =>
          import('./app/project/sport-disciplines/sport-disciplines.page').then((m) => m.SportDisciplinesPage),
        canActivate: [roleGuard([1])],
      },
      {
        path: 'coaches',
        loadComponent: () => import('./app/project/coaches/coaches.page').then((m) => m.CoachesPage),
        canActivate: [roleGuard([1])],
      },
      {
        path: 'classes',
        loadComponent: () => import('./app/project/classes/classes.page').then((m) => m.ClassesPage),
        canActivate: [roleGuard([1])],
      },
      {
        path: 'class-reports',
        loadComponent: () => import('./app/project/class-reports/class-reports.page').then((m) => m.ClassReportsPage),
        canActivate: [roleGuard([1])],
      },
      {
        path: 'sportInjuries',
        loadComponent: () => import('./app/project/sport-injuries/sport-injuries.page').then((m) => m.SportInjuriesPage),
        canActivate: [roleGuard([1])],
      },
      {
        path: 'athletes',
        loadComponent: () => import('./app/project/athletes/athletes.page').then((m) => m.AthletesPage),
        canActivate: [roleGuard([1])],
      },
      {
        path: 'athletes/:id/profile',
        loadComponent: () => import('./app/project/athletes/athlete-profile.page').then((m) => m.AthleteProfilePage),
        canActivate: [roleGuard([1])],
      },
      {
        path: 'attendance',
        loadComponent: () => import('./app/project/attendance/class-attendance.page').then((m) => m.ClassAttendancePage),
        canActivate: [roleGuard([1])],
      },
      {
        path: 'userLog',
        loadComponent: () => import('./app/project/user-auth-logs/user-auth-logs').then((m) => m.UserAuthLogsComponent),
        canActivate: [roleGuard([1])],
      },
      {
        path: 'expiring',
        loadComponent: () =>
          import('./app/project/expiring-enrollments/expiring-enrollments').then((m) => m.ExpiringEnrollmentsPage),
        canActivate: [roleGuard([1])],
      },

      // اختیاری: فقط admin
      {
        path: 'uikit',
        loadChildren: () => import('./app/pages/uikit/uikit.routes'),
        canActivate: [roleGuard([1])],
      },
      { path: 'documentation', component: Documentation, canActivate: [roleGuard([1])] },
      {
        path: 'pages',
        loadChildren: () => import('./app/pages/pages.routes'),
        canActivate: [roleGuard([1])],
      },
    ],
  },

  // عمومی
  { path: 'landing', component: Landing },
  { path: 'notfound', component: Notfound },
  { path: 'auth', loadChildren: () => import('./app/pages/auth/auth.routes') },

  // 404
  { path: '**', redirectTo: '/notfound' },
];
